/**
 * 路由的主文件
 * 如果后续路由组件很多时，再按模块划分出来，现在全部集成在这里
 */

import { createRouter, createWebHashHistory } from "vue-router";

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/request_manage",
      name: "request_manage",
      component: () => import("../views/request-manage/index.vue"),
    },
    {
      path: "/request_version_manage",
      name: "request_version_manage",
      component: () => import("../views/request-version-manage/index.vue"),
    },
    {
      path: "/request_download_manage",
      name: "request_download_manage",
      component: () => import("../views/request-download-manage/index.vue"),
    },
    {
      path: "/request_download_version_manage",
      name: "request_download_version_manage",
      component: () =>
        import("../views/request-download-version-manage/index.vue"),
    },
    {
      path: "/request_module_download_manage",
      name: "request_module_download_manage",
      component: () =>
        import("../views/request-module-download-manage/index.vue"),
    },
    {
      path: "/request_ui_controller",
      name: "request_ui_controller",
      component: () => import("../views/ui-component-manager/index.vue"),
    },
    {
      path: "/workflow_controller",
      name: "workflow_controller",
      component: () => import("../views/workflow-component-manager/index.vue"),
    },
    {
      path: "/standard_valuation_management",
      name: "standard_valuation_management",
      component: () => import("../views/evaluate-component-manager/index.vue"),
    },
    {
      path: "/demand_manage",
      name: "demand_manage",
      component: () => import("../views/demand-manage/index.vue"),
    },
    {
      path: "/demand_manage_version",
      name: "demand_manage_version",
      component: () => import("../views/demand-manage/index-version.vue"),
    },
    {
      path: "/request_check_rule",
      name: "request_check_rule",
      component: () => import("../views/demand-manage/RequestCheckRuleList.vue"),
    },
    {
      path: "/request_standard_distribute",
      name: "request_standard_distribute",
      component: () => import("../views/request-standard-distribute/index.vue"),
    },
    {
      path: "/non_function_request",
      name: "non_function_request",
      component: () => import("../views/non_func_req/index.vue"),
    },
    {
      path: "/delivery_require",
      name: "delivery_require",
      component: () => import("../views/delivery-require/index.vue"),
    },
    {
      path: "/icon_image",
      name: "icon_image",
      component: () => import("../views/icon-image/index.vue"),
    },
    /**需求市场->需求规范->数据实体 */
    {
      path: "/data_entity",
      name: "data_entity",
      component: () => import("../views/data-entity/data-entity.vue"),
    },
    /**需求市场->需求规范->Adap帮助 */
    {
      path: "/adap_user_manual",
      name: "adap_user_manual",
      component: () => import("../views/adap-user-manual/adap-user-manual.vue"),
    },
    /**需求市场->需求库->需求 */
    {
      path: "/request_in_lib",
      name: "request_in_lib",
      component: () => import("../views/request-lib/request-in-lib/index.vue"),
    },
    /** 提示词模板管理 */
    {
      path: "/prompt_template",
      name: "prompt_template",
      component: () => import("../views/prompt-template/PromptTemplate.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  console.log("router output:", to, from);
  next();
});
export default router;
